import React from 'react';
import EditableProfilePhoto from './EditableProfilePhoto.js';

export default function InstructorProfile({instructor, canEditPhoto = false, plain = false}) {
	const safeInstructor = instructor || {
		id: 0,
		firstName: '',
		lastName: '',
		nickname: '',
		usrName: '',
		phone: '',
		phoneLink: '',
		email: '',
		profilePhotoUrl: ''
	};
	const displayName = `${safeInstructor.firstName} ${safeInstructor.lastName}`.trim() || safeInstructor.usrName || '';

	if (!instructor) {
		return '';
	}

	const profileContent = (
		<div className="usrprofile txt_l">
			<EditableProfilePhoto
				photoUrl={safeInstructor.profilePhotoUrl}
				displayName={displayName}
				canEditPhoto={canEditPhoto}
				uploadUrl="/rest/uploadInstructorProfilePhoto"
				deleteUrl="/rest/deleteInstructorProfilePhoto"
				entityKey={safeInstructor.id}
				avatarWidth="7rem"
				avatarHeight="7rem"
			/>

			<div className="usrprofile_content">
				<div className="usrprofile_name fnt_b">{safeInstructor.firstName} {safeInstructor.lastName} {safeInstructor.nickname !== '' ? `(${safeInstructor.nickname})` : ''}</div>

				{safeInstructor.phone !== '' ? (
					<a className="usrprofile_link lnk1 cr_p" href={`tel:${safeInstructor.phoneLink}`}>
						{safeInstructor.phone}
					</a>
				) : (
					''
				)}

				{safeInstructor.email ? (
					<a className="usrprofile_link usrprofile_email lnk1 cr_p" href={`mailto:${safeInstructor.email}`}>
						{safeInstructor.email}
					</a>
				) : (
					''
				)}
			</div>
		</div>
	);

	if (plain) {
		return profileContent;
	}

	return (
		<div className="list" key="INSTRUCTOR_PROFILE">
			<div className="list_in">
				{profileContent}
			</div>
			<div className="zero h05" />
		</div>
	);
}